import { OperatingUnit } from "@farmact/model/src/model/OperatingUnit";

export function getOperatingUnitName(operatingUnit: OperatingUnit): string {
    return operatingUnit.name ?? operatingUnit.companyNumber ?? "Betrieb";
}
